import { connect } from 'react-redux';
import { get } from 'lodash';
import Account from '../../components/user/Account';
import { ACTIVE } from '../../constants/userStatus';

function mapStateToProps(state) {
  return {
    isActive: get(state, 'user.currentUser.status.id') === ACTIVE,
    isFreeOnly: state.settings.freeOnly,
    enableAccountLimit: get(state, 'settings.enableAccountLimit', !state.settings.freeOnly),
    isPxcEnabled: get(state, 'settings.enablePxc', false)
  };
}

const AccountRouteHandler = connect(
  mapStateToProps,
  {}
)(Account);

export default AccountRouteHandler;
